import script from "./psiShopPaymentOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopPaymentOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiShopPaymentOrder.vue?vue&type=style&index=0&id=5c69c963&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c69c963"]])

export default __exports__